/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, View, KeyboardAvoidingView, ActivityIndicator } from 'react-native'
import {WebView} from 'react-native-webview'
import { connect } from 'react-redux'
import {
  Container, Icon, Header,
  Content, ListItem,
  CheckBox, Thumbnail,
  Text, Left, Body, Right, Item, Input, Button
} from 'native-base';
import styles from './Styles/WebViewScreenStyle'
import BackButtonComponent from '../Components/BackButtonComponent';
//import Pdf from 'react-native-pdf';
import NavigationBar from "../Components/NavigationBar"
class WebViewScreen extends Component {
  // static navigationOptions = ({ navigation }) => {

  //   const { params = {} } = navigation.state
  //   let headerLeft = null
  //   let headerRight = null
  //   let title = params.title
  //   console.tron.log(`props on naviagtion ${this.props}`);


  //   headerLeft = (
  //     <BackButtonComponent onPress={() => navigation.goBack()} />
  //   )
  //   return {
  //     headerLeft,
  //     headerRight,
  //     title: title
  //   }
  // }
  static navigationOptions = {
    header : null
  }


  componentDidMount() {
    this.navigationBar.setLeftNavBarButtons([
      { onPress: this.onBackPress, type: 'back' },
    ])
  }
  onBackPress = () => {
    this.props.navigation.goBack()
  }
  renderLoadingView = () => {
    return (
      <ActivityIndicator

        size='large'
        styles={styles.activityIndicator}
      />
    );
  }
  render() {
    const { params = {} } = this.props.navigation.state
    console.log(`webview ${JSON.stringify(params)}`)
    return (
      <View style={styles.container}>
        <NavigationBar
         
          ref={(view) => {
            if (view) this.navigationBar = view
          }}
          title={params.title}
        />
        <WebView
          activityIndicator={this.renderLoadingView()}
          source={{ uri: params.url }}

          fitWidth={true}
          onLoadComplete={(numberOfPages, filePath) => {

          }}
          onPageChanged={(page, numberOfPages) => {

          }}
          onError={(error) => {

          }}
          style={styles.pdf} />
      </View>
    )
  }
}


export default connect()(WebViewScreen)

